import { BaseEntite } from '../../../../common/src/entities';
import ChampAutocompletion, { PropsDAutocompletion } from './ChampAutocompletion';
import { PropsDeCreationEntite } from '../Dashboard/Utils/FormulaireCreationEntite';
import React, { forwardRef, ReactElement, ReactNode, useState } from 'react';
import { ValueType } from 'react-select';
import { Modal } from 'react-bootstrap';

export type PropsDeDropdown<TEntite extends BaseEntite> = PropsDAutocompletion<TEntite> & {
    modalBody?: (props: Partial<PropsDeCreationEntite<TEntite>>) => ReactNode;
    modalSize?: 'sm' | 'lg' | 'xl';
    valeur?: ((data: TEntite[] | undefined) => ValueType<TEntite, false>) | ValueType<TEntite, false>;
    avecUnBouton?: boolean;
    affichageOption?: (entite: TEntite) => ReactNode;
};

function DropdownAvecRef<TEntite extends BaseEntite>(props: PropsDeDropdown<TEntite>, ref): ReactElement {
    const [showModal, setShowModal] = useState(false);
    const [newName, setNewName] = useState('');
    const [enCreation, setEnCreation] = useState(false);
    const { entite, enErreur, erreur, modalBody, modalSize, valeur, avecUnBouton, appendedChildren, ...rest } = props;

    return (
        <>
            <ChampAutocompletion
                ref={ref}
                isClearable={true}
                isDisabled={enCreation}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.name}
                onCreateOption={(option) => {
                    setNewName(option);
                    setShowModal(true);
                    setEnCreation(true);
                }}
                getNewOptionData={(id, texte) => ({ name: texte, id: +id } as TEntite)}
                avecUnBouton={avecUnBouton}
                appendedChildren={appendedChildren}
                {...rest}
            />
            <Modal
                scrollable
                size={modalSize}
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                    setEnCreation(false);
                }}
            >
                {modalBody?.({
                    valeursInitiales: { name: newName } as Partial<TEntite>,
                    modal: true,
                    succes: (t) => {
                        if (rest.onChange) rest.onChange(t, { action: 'create-option' });
                        setEnCreation(false);
                    },
                    onBeforeSave: () => setShowModal(false),
                }) ?? null}
            </Modal>
        </>
    );
}

const DropdownSansEntite = forwardRef(DropdownAvecRef);

export default DropdownSansEntite;
